import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user:         null,
    isAuthReady:  false,

    // Active tenant
    tenantId:      null,
    role:          null,
    apiBase:       null,
    apiKey:        null,
    tenantStatus:  null,
    ownedTenantId: null, // tenant the user created (owner_uid === uid)

    // All tenants this user belongs to
    tenants:       [], // [{ tenantId, role }]
    notifications: [], // admin notifications from tenant
  }),

  actions: {
    setUser(user) {
      this.user        = user;
      this.isAuthReady = true;
    },

    setTenant({ tenantId, role, apiBase, apiKey, tenantStatus, tenants, ownedTenantId } = {}) {
      this.tenantId      = tenantId      ?? null;
      this.role          = role          ?? null;
      this.apiBase       = apiBase       ?? null;
      this.apiKey        = apiKey        ?? null;
      this.tenantStatus  = tenantStatus  ?? null;
      if (ownedTenantId !== undefined) this.ownedTenantId = ownedTenantId ?? null;
      if (tenants) {
        this.tenants = tenants;
      } else if (tenantId && !this.tenants.find(t => t.tenantId === tenantId)) {
        this.tenants = [...this.tenants, { tenantId, role }];
      }
      // Persist last active workspace so it's restored after page refresh
      if (tenantId) localStorage.setItem("last_tenant_id", tenantId);
    },

    clearUser() {
      this.user          = null;
      this.tenantId      = null;
      this.role          = null;
      this.apiBase       = null;
      this.apiKey        = null;
      this.tenantStatus  = null;
      this.ownedTenantId = null;
      this.tenants       = [];
      this.notifications = [];
      this.isAuthReady   = true;
    },
  },

  getters: {
    isAuthenticated: (state) => !!state.user,
    hasTenant:       (state) => !!state.tenantId,
    isAdmin:         (state) => state.role === "admin",
    isEditor:    (state) => state.role === "editor",
    isViewer:       (state) => state.role === "viewer",
    hasBackend:      (state) => !!state.apiBase && !!state.apiKey,
  },
});